import { createSelector } from 'reselect';

import { dashboardSelector } from '../dashboard';

export const userSelector = createSelector(dashboardSelector, (dashboard) => dashboard.user);
export const passwordSelector = createSelector(userSelector, (user) => user.password);
export const preferencesSelector = createSelector(userSelector, (user) => user.preferences);
